module.exports = __webpack_public_path__ + "img/1.01b43581.jpg";